import type { propsInterface } from '~/modules/design-system/sections/s-markdown.vue'
import type { schemaType as campaignSchemaType } from '~/modules/api/strapi/campaign/detail/schema'
import type { schemaType as howPlatformWorksPageSchemaType } from '~/modules/api/strapi/how-platform-works-page/schema'
import type { schemaType as legalInfoPageSchemaType } from '~/modules/api/strapi/legal-info-page/schema'
import type { schemaType as privacyPolicyPageSchemaType } from '~/modules/api/strapi/privacy-policy-page/schema'
import type { schemaType as accessibilityPageSchemaType } from '~/modules/api/strapi/accessibility-page/schema'

export const useToSMarkdown = () => {
  const fromStrapiCampaignDetail = (
    data: campaignSchemaType,
  ): propsInterface['text'] | undefined => {
    if (data.attributes.text) {
      const markdown = data.attributes.text

      return markdown
    }
    return undefined
  }

  const fromStrapiHowPlatformWorksPage = (
    data: howPlatformWorksPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  const fromStrapiLegalInfoPage = (
    data: legalInfoPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  const fromStrapiPrivacyPolicyPage = (
    data: privacyPolicyPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  const fromStrapiAccessibilityPage = (
    data: accessibilityPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  return {
    fromStrapiCampaignDetail,
    fromStrapiHowPlatformWorksPage,
    fromStrapiLegalInfoPage,
    fromStrapiPrivacyPolicyPage,
    fromStrapiAccessibilityPage,
  }
}
